import { t } from '@billes/translator-client'
import React from 'react'

const styles = {
  error: touched => {
    return {
      color: 'red',
      opacity: touched ? 1 : 0,
      fontSize: 12,
      bottom: 0,
      top: 55,
      display: 'block',
      position: 'absolute'
    }
  }
}

const FieldError = ({ field }) => {
  if (!field.errorMessage) {
    return null
  }
  let param = field.errorMessage.value ? {} : null
  if (param) {
    param[field.errorMessage.param] = field.errorMessage.value
  } else {
    param = {}
  }
  return (
    <span style={styles.error(field.isTouched)}>
      {t(field.errorMessage.key, param)}
    </span>
  )
}

export default FieldError



// WEBPACK FOOTER //
// ./src/components/inputs/fieldError.js